<template>
    <div>
    	<ul class="sidebar-menu" style="border-bottom: 1px solid rgb(173, 180, 187); box-shadow: rgb(243, 253, 255) 0px 1px 0px;">
            <li class="header" style="color: #999; padding: 5px 0px 0px 5px; margin: 5px 0px; background-color:inherit;"> <!--border-bottom: 1px solid rgb(9, 12, 15); box-shadow: rgb(80, 94, 101) 0px 1px 0px;-->
                <form class="sidebar-form row" :style="'margin-left:' + ( right ? '10px' : '0px')+';'">
                    <div class="col-xs-10 sidebar-text" style="padding: 0px; font-size: larger;">
                      <span id="primo_span" v-if="idRoot != -1">
                        <popover-alert effect="fade" placement="bottom" classes="in_sidebar" :content="root_info" :id="'popoup_in_sidebar'"
                          :popoverCondition="info_catalog"
                          :popoverStyle="{'max-width': '200px', 'width': '200px', 'font-size': 'small', 
                                          'height': '60px', 'position':'fixed'}" 
                          :showOK="false" :showNO="false" :textStyle="{color: '#222'}" :arrowStyle="{left:'6%', top:'-9px'}">

                          <i id="info_catalog" :class="$root.catalog_icon" aria-hidden="true" 
                            style="cursor:pointer; margin-right: 5px; font-size: 1.1em;" @click="toggleCatInfo($event)"> 
                            <div style="font-family: 'Source Sans Pro'; display: inline; margin-left: 5px;">{{desRoot}}</div>
                          </i> 

                        </popover-alert>
                      </span>
                    </div> 
                </form>
            
            </li>
        </ul>
        <!-- finding_target == true quando sto eseguendo uno scorrimento dell'albero relativo a un'azione di navigazione diretta (es. breadcrumb) -->
        <!-- la lista deve comunque essere renderizzata per permettere alla navigazione di eseguire correttamente, quindi uso v-show piuttosto che v-if -->
        <div id="sideOpen" v-show="!finding_target" style="padding-bottom: 10px;">
            
            <ul v-if="displaying.length > 0 && ready" :style="'overflow-y:' + overflow + ';overflow-x: hidden; max-height:' + maxHeight + ';margin-left:' + (right ? '5px' : '0px')+';'" id="side-list" class="sidebar-menu">
                <li class="pageLink" v-for="(item, index) in displaying">
                  <recursiveItem :item="item" :key="item.sid" :configs="merged_c"
                  @shrimp_build_path="EndShrimpBuildPath"></recursiveItem>
                </li>
            </ul>
        </div>
        <!-- spinner 
        <div v-if="finding_target" class='uil-rolling-css loading-nav-spinner' style='transform:scale(0.50); 
        position: absolute; margin: 0 auto; top: 100px; right: 0px; left: 50px;'>
            <div>
                <div></div>
                <div></div>
            </div>
        </div>-->
        <div v-if="finding_target" class="sk-cube-grid">
          <div class="sk-cube sk-cube1 loading-nav-waiter"></div>
          <div class="sk-cube sk-cube2 loading-nav-waiter"></div>
          <div class="sk-cube sk-cube3 loading-nav-waiter"></div>
          <div class="sk-cube sk-cube4 loading-nav-waiter"></div>
          <div class="sk-cube sk-cube5 loading-nav-waiter"></div>
          <div class="sk-cube sk-cube6 loading-nav-waiter"></div>
          <div class="sk-cube sk-cube7 loading-nav-waiter"></div>
          <div class="sk-cube sk-cube8 loading-nav-waiter"></div>
          <div class="sk-cube sk-cube9 loading-nav-waiter"></div>
        </div>
	</div>
</template>

<script>
import { eventBus } from "../eventbus.js";
import recursiveItem from "./tree/recursive-list-item.vue";
import PopoverAlert from "./dynamic/popoverWrapper/Popover.vue";

var h;
var w;
var vm;

$(document).ready(function() {
  var h =  $(window).height();
  if (vm != null) {
    vm.$root.WINDOW_HEIGHT = h;
    vm.setMaxHeight();
  }
});
// setMaxHeight monitora l'altezza massima dell'albero, per adattarla al massimo consentito
$(window).resize(function() {
   var h =  $(window).height();
  if (vm != null) {
    vm.$root.WINDOW_HEIGHT = h;
    eventBus.$emit("heightMutation")
    
    try {
      vm.$nextTick(function(){
        $('#route-view-parent').css('min-height', (vm.$root.WINDOW_HEIGHT - 55) + 'px');
      });
      
    } catch(err){}

    vm.setMaxHeight();
  }
});

/* $(window).mousedown(function(e) { //al rilascio del mouse su una qualunque area della finestra chiudo il popup di info catalogo
  console.log('MOUSEDOWN')
  vm.info_catalog = false;
}); */

import loki_db_loader from '../mixins/loki_db_loader';
export default {
  mixins: [loki_db_loader],
  mounted: function() {
    vm = this;
    vm.setMaxHeight();
    try {
      vm.$nextTick(function(){
        $('#route-view-parent').css('min-height', (vm.$root.WINDOW_HEIGHT - 55) + 'px');
      });
      
    } catch(err){}
    this.overrideConfigs();

    var clm = localStorage.getItem("current_loaded_model")
    this.$root.catalog_icon = (clm && clm!='null') ? this.$root.icons.left : this.$root.icons.info
  },
  created: function() {
    
    eventBus.$on("nav_to", function(params) {
      
      var path = params.path;
      var focus = params.focus;
      var nav_promise = params.nav_promise
      
      //intercetto l'evento di nav_to per dare inizio a un'operazione di navigazione diretta
      if (path.length == 1) {
        if(focus!=null){
          if (vm.displaying.length > 0) {
            vm.direct(path, focus, nav_promise);
          } else {
            //se displaying è vuoto, significa che sto facendo una richiesta di navigazione diretta prima che loadIndex abbia terminato di reperire i primi figli di Root
            //in tal caso, delego a loadIndex di richiamare la procedura di navigazione al momento opportuno
            vm.direct_path = path;
            vm.direct_focus = focus;
            vm.nav_promise = nav_promise;
          }
        }else{
          //se path == 1, sto cercando di ricaricare la root, e loadIndex è predisposto per fare esattamente questo
          vm.loadIndex();
        }
      } else {
        //altrimenti, dò il via alla navigazione diretta vera e propria
        vm.finding_target = true;
        if (vm.displaying.length > 0) {
          vm.direct(path, focus, nav_promise);
        } else {
          //se displaying è vuoto, significa che sto facendo una richeista di navigazione diretta prima che loadIndex abbia terminato di reperire i primi figli di Root
          //in tal caso, delego a loadIndex di richiamare la procedura di navigazione al momento opportuno
          vm.direct_path = path;
          vm.direct_focus = focus;
          vm.nav_promise = nav_promise;
        }
      }
      $("#side-list").animate(
        {
          scrollTop: 0
        },
        0
      );
    });
    eventBus.$on("end_nav", function(leaf, nav_promise) {
      //l'evento di end_nav viene scatenato dall'elemento della lista in cui si è conclusa la navigazione diretta
      vm.finding_target = false;
      //risolvo la promise di navigateTo
      nav_promise.resolve();
      this.$nextTick(function() {
        //tramite il riferimento all'elemento raggiunto, eseguo un opportuno focus della scrollbar
        var grabbed = $("a[id='" + leaf + "']");
        $("#side-list").animate(
          {
            scrollTop: grabbed.offset().top - 100
          },
          300
        );
      });
    });
    eventBus.$on("gotIndex", function() {
      console.log("___ GotIndex Event ___")
      vm.finding_target = true; //all'on gotIndex faccio subito vedere il loader con i quadratini
      // appena ho un indice selezionato (e comunque ogni volta che refresho la pagina)
      // verifico se c'è da cominciare / riprendere la procedura di scaricamento in cache dei cataloghi
      // in ogni caso, che il catalogo sia in cache o no, la procedura di download comunque esegue una chiamata per ogni catalogo in lista (partendo da quello selezionato)
      // posso contare quindi che $root.dbCatalog sia correttamente valorizzato, anche se in modo asincrono
      vm.$root.START_DOWNLOAD();

      var INIT_TREE_NAVIGATION = function(){
         vm.idRoot = vm.$root.index_as_root;
         vm.loadIndex();
      }
      // se però noto che l'applicazione è offline, ho bisogno del catalogo scaricato subito per inziare la navigazione
      if(vm.$root.preferences.useOffline && !navigator.onLine){
        vm.loadOfflineCatalog(INIT_TREE_NAVIGATION);
      } else if(vm.$Configs.autoLogin){
        var cookies = decodeURIComponent(document.cookie).split(';');
        console.log('COOKIESSSSS')
        console.log(cookies)
        var ou = 'originalUrl=',
            foundCookie = false,
            path;
        
        for (var i = 0; i < cookies.length; i++) {
          var ouCookie = cookies[i];
          if (ouCookie.indexOf('originalUrl') > -1) {
            var pos = ouCookie.indexOf('=');
            path = ouCookie.substring(pos+1, 10000);
            foundCookie = true;
            break;
          }
        }

        if(foundCookie){
          console.log('originalUrl extracted from cookie: ', path)
          
          var detailStart = path.indexOf("/detail/") + 8,
              detailEnd = path.indexOf("?", detailStart),
              id = path.substring(detailStart, detailEnd);

          id = vm.$root.decode(id); 

		      var start = path.indexOf("p=")
          if(start > -1){
            var params = path.substring(start + 2),
                lang_index = params.indexOf("&lang");
            
            if(lang_index > -1){
              params = params.substring(0, lang_index)
            }  
                
            var decodedparams = decodeURIComponent(params),
                steps = decodedparams.split('?'),
                dp = [];
            for (var i = 0; i < steps.length; i++) {
              dp.push({
                id: steps[i]
                })
            }
            
            //Aggiungo l'ID decodificato come ultimo elemento dell'array
            dp.push({id: id});
            console.log('COMPLETE DIRECT_PATH')
            console.log(dp)
            vm.direct_path = dp;
            console.log('INIT_TREE_NAVIGATION - TERZO');
            INIT_TREE_NAVIGATION();
          }else{
            alert('url parameters not found')
          }
          
          //elimino il cookie
          var date = new Date()
          date.setFullYear(date.getFullYear() - 1)
          console.log(date)
          document.cookie = ouCookie+'; expires='+ date +'; path=/; sameSite=strict';
        }else{
          console.log('INIT_TREE_NAVIGATION - PRIMO');
          INIT_TREE_NAVIGATION();
        }
        
      } else {
        console.log('INIT_TREE_NAVIGATION - SECONDO');
        INIT_TREE_NAVIGATION();
      }
      
    });

    this.overflow = bowser.name.toLowerCase().includes('edge') ? 'hidden' : 'auto'
  },
  props: {
    //configurazione che regola se l'albero è da disporre a destra o a sinistra
    right: Boolean,
    configs: {
      type: Object,
      default: function() {
        return {
          ID: "mainForm.navTree",
          showId: false,
          showValidity: false
        };
      }
    }
  },
  components: {
    recursiveItem,
    PopoverAlert
  },
  data: function() {
    return {
      idRoot: -1,
      desRoot: "",
      root_info: "",
      displaying: [],
      maxHeight: "0px",
      merged_c: {},
      start_w: 0,

      finding_target: false,

      ready: false,

      //se la richiesta di navigazione diretta viene effettuata prima del termine della loadIndex
      //salvo il riferimento all'obbiettivo della ricerca, e richiamo la procedura al termine della loadIndex
      direct_path: null,
      direct_focus: null,
      nav_promise: null,

      info_catalog: false,
      overflow: ''
    };
  },
  methods: {
    loadOfflineCatalog: function(callback){
        // prima verifico che ci sia un record valido per il catalogo nella cache (loaded_cat TRUE)
        var current = null;
        try {
            var cache = this.$root.dataReferences.getCollection("indiceCache");
            console.log(cache)
            current = cache.find({'id': Number(this.$root.root_index), 'loaded_cat': true })[0];
        } catch (err){
            console.log(err)
            current = null;
        }
        console.log(current)
        if(current){
            // se il record esiste ed è valido, effettuo la chiamata verso il catalogo che, a meno di inconvenienti (cache svuotata), dovrà essere restituito dalla disk cache
            console.log("FOUND CURRENT CATALOG CACHE RECORD")
            console.log(current)
            this.loadLoki(this.$root.msPath +"/"+ this.$Configs.licenseId +"/cat/" + current.file, "destructured", false , false).then((res) => {
                this.$root.dbCatalog = res;
                // caricamento catalogo da cache andato a buon fine
                console.log('dbCatalog loki db loaded', res)
                callback();
            }, (err) => {
                console.log('error loadDatabase dbCatalog', err)
                callback();
            });
        } else {
            vm.$root.simpleNotification("error", {
              title: vm.$Jed.firstUpperTranslate("error", null),
              message:  vm.$Jed.firstUpperTranslate("index", null) + ' ' +  vm.$Jed.translate("missing in local memory", null)
            })
        }
    },
    hide: function(id) {
      document.getElementById(id).style.display = "none";
    },
    overrideConfigs: function() {
      this.merged_c = this.$Components["mainForm.navTree"];
    },
    //carica i primi figli dell'elemento radice
    loadIndex: function() {
      this.$root
        .microservice({
          role: "catalog",
          cmd: "SearchByFather",
          params: {
            //id padre
            fid: this.idRoot,
            //labels all richiede che il servizio ritorni (tradotte) tutte le informazioni gestite
            labels: "all",
            //laves false indica che non voglio reperire nodi che non hanno figli (parti, con cco == 0)
            leaves: true,
            //meta = true restituisce informazioni relative al percorso nel catalogo
            meta: this.idRoot != "MODELLI", //REPLACED, boh
            prod_info: ["typ"]
          }
        })
        .then(
          response => {
            this.finding_target = false; //appena la chiamata al cmd risponde tolgo il loader con i quadratini
            if(response){
              var res = response.body;
              if(res.error || !res.children){
                var msg = res.error ? res.error : ''
                eventBus.$emit('alert', {
                  message: this.$Jed.firstUpperTranslate("Error in loading catalog", null)+ "<br> <h5>Details: " + "catalog.SearchByFather - " + msg +'</h5>',
                  type: "error",
                  action: ''
                })
                localStorage.setItem('current', null);
                localStorage.setItem('current_root', null);
                localStorage.setItem('current_name', null);
              }else{
                try {
                  res = JSON.parse(response.body);
                } catch (err) {}
                this.displaying = [];
                
                if(this.$root.model_of_cat){
                  if(res.children){

                    for(var i=0; i<res.children.length; i++){
                      if(res.children[i].sid == this.$root.model_of_cat){
                        res.children = [res.children[i]];
                      }
                    }
                  }
                }

                if (res.children) {
                  //recupero info su nome, versione e data pubblicazione del catalogo
                  var catalogs = this.$root.dataReferences.getCollection('catalogs')
                  var curCatId = localStorage.getItem('current_root')
                  curCatId = parseInt(curCatId)
                  var ctg = catalogs.find({"id": curCatId})[0];
                  this.desRoot = ctg.name;
                  this.root_info = this.$Jed.firstUpperTranslate('version')+": "+ ctg.version +"<br>"+this.$Jed.firstUpperTranslate('creation date')+": "+ ctg.date

                  for (var i = 0; i < res.children.length; i++) {
                    var obj = res.children[i];
                    obj.opened = false;
                    this.displaying.push(obj);
                  }
                  if (this.$root.validity != null) {
                    // this.displaying = this.$root.parseValidity(this.displaying);
                  }
                  if (/*vm.finding_target == true &&*/ vm.direct_path != null) {
                    //se entro in questo if, significa che una procedura di navigazione diretta è stata delegata in attesa del termine di loadIndex

                    console.log('OOOOOOOOOOOOOOOOOOOOOO')
                    console.log(vm.direct_path)
                    console.log(vm.direct_focus)
                    console.log(vm.nav_promise)
                    
                    vm.$nextTick(function() {                      
                      vm.direct(vm.direct_path, vm.direct_focus, vm.nav_promise);
                    });
                  
                  } else {
                    this.$nextTick(function(){
                      if (this.$children.length > 0) {
                        try {
                          if(!this.$children[1].item.opened){
                            // ho notato che cercare di ricaricare la pagina con focus sulla root, scatena due loadIndex (da @gotIndex e @nav_to) che vanno in conflitto cercando di espandere il nodo
                            // dal momento che sto navigando verso l'indice, non ha mai senso collassare il contenuto, quindi mi assicuro di chiamare expand solo quando il contenuto è nascosto (item.opened == false)
                        
                            this.$children[1].expand()
                          }
                        } catch(err){
                          console.log(err)
                          this.$children[1].expand()
                        }
                        
                      }
                    })
                  }
                }

                var source = res.answer ? res.answer : res.children[0];
                var active_item = { 
                    id: source.sid, 
                    des: source.des,
                    typ: source.typ,
                    spe: source.spe, 
                    pos: source.pos,
                    fid: source.fid,
                    qty: source.qty,
                    spi: source.spi,
                    not: source.not
                  };
                  
                this.$root.active_tree_item = active_item;
                this.$root.active_tree_path = [];
                eventBus.$emit("openSidebarMenu");
                eventBus.$emit("active_changed");
                this.ready = true;
                
                //se il browser è Edge, quando la lista è stata caricata gestisco l'evento della rotella del mouse su di essa
                if(bowser.name.toLowerCase().includes('edge') && this.displaying && this.displaying.length>0 && this.ready){
                  vm.$nextTick(function(){
                    console.log('SIDELIST!')
                    try{
                      document.getElementById('side-list').addEventListener('wheel', function(event){
                        var y = document.getElementById('side-list').scrollTop
                        console.log(y)
                        if (event.deltaY < 0){
                          console.log('scrolling up');
                          $("#side-list").animate({scrollTop: -100+y}, 0);
                        }else if (event.deltaY > 0){
                          console.log('scrolling down');
                          $("#side-list").animate({scrollTop: 100+y}, 0);
                        }
                        
                      })
                    }catch(e){console.log(e)}
                  })
                }else{
                  console.log('NO LIST')
                }
              }
            }
          },
          err => {
            this.loading = false;
            console.log('SidebarMenu')
            console.log(err)
            //vedi gestione errore in main.js > microservice
          }
        )
        .catch(err => {
          console.log(err);
          var msg = ''
          if(err)msg = err.body && err.body.error ? err.body.error : err.message ? err.message : ''
          eventBus.$emit('alert', {
            message: "Application caught an error <br> <h5>Details: " + "catalog.SearchByFather - " + msg +'</h5>',
            type: "error",
            action: ''
          })
        })	
    },
    setMaxHeight: function() {
      if(this.$root.WINDOW_HEIGHT != null){
        this.maxHeight = this.$root.WINDOW_HEIGHT - 95 + "px";
      }
    },
    EndShrimpBuildPath: function(e){
      //risolvo la promise scatenata dal nodo attivo con il path appena creato
      e.resolve(e.path)
    
    },
    direct: function(path, focus, nav_promise) {
      this.direct_path = null;
      //REPLACED var step = 1
      var step = 0;
      var extract;
      try {
        extract = path[step].id;
      } catch (err) {
        console.log(err)
      }
      for (var i = 0; i < this.displaying.length; i++) {
        this.displaying[i].opened = false;
      }
      var found = false;

      for (var i = 0; i < this.$children.length; i++) {
        if (this.$children[i].item != null) {
          if (this.$children[i].item.sid == extract) {
            found = true;
            this.$children[i].expand(path, step, focus, nav_promise);
          }
        }
      }
      if(!found){
        nav_promise.reject("root children not found")
      }
    },
    toggleCatInfo: function(e){
      //se nell'albero è caricata una matricola, navigo al nodo del catalogo. Altrimenti apro il popover con le info sul catalogo
      if(this.$root.model_of_cat){
        //se devo tornare indietro, resetto la root e l'info sul modello caricato (sia variabili di Vue sia localStorage)
        this.$root.index_as_root = 'MODELLI'
        localStorage.setItem("current", this.$root.index_as_root);
        this.$root.model_of_cat = null;
        localStorage.setItem("current_loaded_model", null);
        this.info_catalog = false;
        this.$root.catalog_icon = this.$root.icons.info
        eventBus.$emit("gotIndex");
      }else{
        this.info_catalog = true;
        console.log('TOGGLE')
        $('#popoup_in_sidebar').mousedown(function(event){ //il click sull'area che comprende il popup non ne innesca la chiusura
          event.stopPropagation();
          console.log('popoup_in_sidebar click event')
        });
      }
    }
  }
};
</script>

<style scoped>
#sideOpen {
  display: inherit;
}
#sideClosed {
  display: none;
}
.sidebar-collapse #sideOpen {
  display: none;
}
.sidebar-collapse #sideClosed {
  display: inherit;
}

.sidebar-collapse .loading-nav-spinner {
  display: none;
}

.sidebar-form {
  margin: 0px 10px;
  border-style: none;
  display: flex;
  align-items: center;
}
#sideClosed .sidebar-form {
  display: inherit !important;
  margin: 5px 1px;
}
#sideClosed .sidebar-form > div {
  text-align: center !important;
}
</style>

<style>
::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  background-color: #f5f5f5;
  border-radius: 0px !important;
}

::-webkit-scrollbar {
  width: 8px;
  height: 8px;
  background-color: #f5f5f5;
}

::-webkit-scrollbar-thumb {
  border-radius: 0px;
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
}

.icon-text-container {
  display: inline;
  padding: 5px;
  padding-left: 0px;
  margin-left: 0px;
}

.hide-collapse {
  padding: 0px;
  padding-left: 5px;
  display: inline;
}

.icon-toggle-validity {
  font-family: sans-serif;
  position: relative;
  top: -6px;
  left: -1px;
}

.side-branch {
  height: 41px;
  width: 9px;
  float: left;
}

.detail > .panel {
  padding: 0px;
  margin: 0px;
  border-color: #374850;
  color: #b8c7ce;
  border-style: solid;
  border-bottom-width: 1px !important;
}

.detail .panel-heading {
  background-color: #1a2226;
  color: #b8c7ce;
  border-color: #374850;
}
.detail .panel-body {
  background-color: #222d32;
}

.detail .panel-heading,
.detail .panel-body {
  padding: 0px 5px;
  text-align: center;
  line-height: 20px;
}

.detail > .col-xs-6.sx,
.detail > .col-xs-6.sx > .panel-heading {
  border-top-right-radius: 0px;
  border-bottom-right-radius: 0px;
  border-right-style: none;
}

.detail > .col-xs-12.sx {
  margin-bottom: 0px;
  border-bottom: 0px;
}

.detail > .col-xs-12.dx,
.detail > .col-xs-12.dx > .panel-heading {
  border-top-right-radius: 0px;
  border-top-left-radius: 0px;
}

.detail > .col-xs-6.dx,
.detail > .col-xs-6.dx > .panel-heading {
  border-top-left-radius: 0px;
  border-bottom-left-radius: 0px;
  border-left-style: none;
}

.first {
  margin-left: 10px;
}

.child {
  margin-left: 20px;
}

i {
  margin-left: 5px;
}

.row-wrap {
  width: 100%;
  margin: 0px;
  padding: 0px 4px;
  min-width: 350px;
}

.sideless {
  padding-left: 0px;
  padding-right: 0px;
}

.first-pad {
  padding-left: 5px !important;
}

.branch {
  height: 50%;
  border-width: 0px;
  border-style: outset;
  border-color: gainsboro;
}

.branch.top {
  border-bottom-width: 1px;
  border-left-width: 1px;
}
.branch.bot {
  border-left-width: 1px;
}
.last > .branch.bot {
  border-style: none;
}

.last > .branch.top {
  border-bottom-left-radius: 3px;
}

.sidebar-menu.child {
    padding-left: 15px;
    margin-left: 4px;
    border-left: 1px outset rgb(184, 199, 206);
}

.sidebar-menu.child.fatherlast {
    border-left-style: none;
}

.aItem {
  cursor: pointer;
  padding: 0px;
  line-height: 41px;
}

.scroll-enter {
  opacity: 0;
}

.scroll-enter-active {
  animation: scroll-in 0.4s ease-out forwards;
  transition: opacity 0.4s;
}

.scroll-leave-active {
  animation: scroll-out 0.4s ease-out forwards;
  transition: opacity 0.25s;
  opacity: 0;
  position: absolute;
}

.scroll-move {
  transition: transform 0.4s;
}

@keyframes scroll-in {
  from {
    transform: translateY(-50px);
  }
  to {
    transform: translateY(0px);
  }
}

@keyframes scroll-out {
  from {
    transform: translateY(0px);
  }
  to {
    transform: translateY(-50px);
  }
}

.active-tree-item, .active-tree-use {
  border-radius: 2px;
}
</style>


// WEBPACK FOOTER //
// src/components/SidebarMenu.vue?7d2c127e